// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../font/Roboto-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../../font/Roboto-Light.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../../font/CenturyGothic.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: "Roboto-Regular";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("truetype");
}
@font-face {
  font-family: "Roboto-Light";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("truetype");
}
@font-face {
  font-family: "Century Gothic";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("truetype");
}
.questions .questions_title h2 {
  text-align: center;
  color: rgb(50, 50, 50);
  font-family: "Century Gothic";
  font-size: 2.4rem;
  line-height: 3rem;
  font-weight: 600;
}
.questions .container_questions {
  margin: 0 auto 50px auto;
  max-width: 1200px;
}
.questions .container_questions .container_question {
  position: relative;
  margin: 10px 30px;
  background-color: rgb(231, 231, 231);
}
.questions .container_questions .container_question .title_question {
  display: grid;
  grid-template-columns: 10% 80% 10%;
  border: none;
  color: rgb(129, 129, 129);
  font-family: "Roboto-Regular";
  font-size: 0.9em;
  font-weight: 600;
  line-height: 1.2em;
  padding: 1.5em 2.5em;
  text-transform: uppercase;
  cursor: pointer;
}
.questions .container_questions .container_question .title_question span {
  display: inline-block;
  pointer-events: none;
}
.questions .container_questions .container_question .title_question:hover {
  background-color: rgb(40, 71, 34);
  color: rgb(255, 255, 255);
}
.questions .container_questions .container_question .title_question[data-active=true] {
  background-color: rgb(40, 71, 34);
  color: rgb(255, 255, 255);
}
.questions .container_questions .container_question .answer {
  background-color: rgb(255, 255, 255);
  text-align: left;
  border: 1px solid rgba(0, 0, 0, 0.1);
  padding: 2.2em 2.5em 2em;
  color: #818181;
  font-family: "Roboto-Light";
  font-size: 17px;
  line-height: 1.42em;
}
.questions .container_questions .container_question .answer a {
  text-decoration: none;
  font-family: "Roboto-Regular";
  color: rgb(40, 71, 34);
  font-weight: 700;
}
.questions .container_questions .container_question .hidden {
  display: none;
}`, "",{"version":3,"sources":["webpack://./styles/fonts.scss","webpack://./src/pages/Questions/Questions.scss"],"names":[],"mappings":"AAAA;EACI,6BAAA;EACA,+DAAA;ACCJ;ADEA;EACI,2BAAA;EACA,+DAAA;ACAJ;ADGA;EACI,6BAAA;EACA,+DAAA;ACDJ;AAPQ;EACI,kBAAA;EACA,sBAAA;EACA,6BAAA;EACA,iBAAA;EACA,iBAAA;EACA,gBAAA;AASZ;AALI;EACI,wBAAA;EACA,iBAAA;AAOR;AALQ;EACI,kBAAA;EACA,iBAAA;EACA,oCAAA;AAOZ;AAMY;EACI,aAAA;EACA,kCAAA;EACA,YAAA;EACA,yBAAA;EACA,6BAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;EACA,oBAAA;EACA,yBAAA;EACA,eAAA;AAJhB;AAOgB;EACI,qBAAA;EACA,oBAAA;AALpB;AASY;EACI,iCAAA;EACA,yBAAA;AAPhB;AAUY;EACI,iCAAA;EACA,yBAAA;AARhB;AAWY;EACI,oCAAA;EACA,gBAAA;EACA,oCAAA;EAEA,wBAAA;EACA,cAAA;EACA,2BAAA;EACA,eAAA;EACA,mBAAA;AAVhB;AAYgB;EACI,qBAAA;EACA,6BAAA;EACA,sBAAA;EACA,gBAAA;AAVpB;AAcY;EACI,aAAA;AAZhB","sourcesContent":["@font-face {\n    font-family: \"Roboto-Regular\"; \n    src: url(\"../font/Roboto-Regular.ttf\") format(\"truetype\");  \n}\n\n@font-face {\n    font-family: \"Roboto-Light\"; \n    src: url(\"../font/Roboto-Light.ttf\") format(\"truetype\");  \n}\n\n@font-face {\n    font-family: \"Century Gothic\"; \n    src: url(\"../font/CenturyGothic.ttf\") format(\"truetype\");  \n}\n\n","@import '../../../styles/fonts.scss';\n\n.questions {\n    .questions_title {\n        h2 {\n            text-align: center;\n            color: rgb(50, 50, 50);\n            font-family: \"Century Gothic\";\n            font-size: 2.4rem;\n            line-height: 3rem;\n            font-weight: 600;\n        }\n    }\n\n    .container_questions {\n        margin: 0 auto 50px auto;\n        max-width: 1200px;\n\n        .container_question {\n            position: relative;\n            margin: 10px 30px;\n            background-color: rgb(231, 231, 231);\n\n            // .front {\n            //     position: absolute;\n            //     z-index: 2;\n            //     top: 0;\n            //     left: 0;\n            //     right: 0;\n            //     bottom: 0;\n            //     display: inline-block;\n            //     border: 2px solid green;\n            // }\n\n            .title_question {\n                display: grid;\n                grid-template-columns: 10% 80% 10%;\n                border: none;\n                color: rgb(129, 129, 129);\n                font-family: \"Roboto-Regular\";\n                font-size: .9em;\n                font-weight: 600;\n                line-height: 1.2em;\n                padding: 1.5em 2.5em;\n                text-transform: uppercase;\n                cursor: pointer;\n\n\n                span {\n                    display: inline-block;\n                    pointer-events: none;\n                }\n            }\n\n            .title_question:hover {\n                background-color: rgb(40, 71, 34);\n                color: rgb(255, 255, 255);\n            }\n\n            .title_question[data-active=\"true\"] {\n                background-color: rgb(40, 71, 34);\n                color: rgb(255, 255, 255);\n            }\n\n            .answer {\n                background-color: rgb(255, 255, 255);\n                text-align: left;\n                border: 1px solid rgba(0, 0, 0, 0.1);\n                // padding: 2.2em 2.5em 2em;\n                padding: 2.2em 2.5em 2em;\n                color: #818181;\n                font-family: \"Roboto-Light\";\n                font-size: 17px;\n                line-height: 1.42em;\n\n                a {\n                    text-decoration: none;\n                    font-family: \"Roboto-Regular\";\n                    color: rgb(40, 71, 34);\n                    font-weight: 700;\n                }\n            }\n\n            .hidden {\n                display: none;\n            }\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
